module.exports = __webpack_public_path__ + "img/middey-logo.44d80d79.png";